<template>
    <div class="">
        <div class="row">
            <div class="curse-top" :style="{ backgroundImage: 'url(' + portada + ')' }">
                <div class="label container-fluid">
                    <div class="title-curse">{{curso.titulo}}</div>
                </div>
                <div class="overlay-boxes o-7"></div>
            </div>
        </div>
        <div class="container mt-4">
            <div class="row">
                <div class="col-md-4">
                    <h4 class="title-studio-item">DIRIGIDO A</h4>
                    <div v-html="curso.dirigido">
    
                    </div>
                    <h4 class="title-studio-item ">OBJETIVOS</h4>
                    <div v-html="curso.objetivos" class="px-4"></div>
                    <h4 class="title-studio-item">CERTIFICACIÓN</h4>
                    <div v-html="curso.certificacion" class="px-4"></div>
                </div>
                <div class="col-md-4">
                    <h4 class="title-studio-item text-center">INFORMACIÓN GENERAL</h4>
                    <div class="row pt-3">
                        <div class="col-md-6 flex-column text-center ">
                            <img src="@/assets/img/logos_cursos/modalidad.png" alt="" class="icon-info">
                            <h5>Modalidad</h5>
                            <div v-html="curso.modalidad"></div>
                        </div>
                        <div class="col-md-6 flex-column text-center ">
                            <img src="@/assets/img/logos_cursos/dias.png" alt="" class="icon-info">
                            <h5>Días</h5>
                            <div v-html="curso.dias"></div>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-6 flex-column text-center ">
                            <img src="@/assets/img/logos_cursos/hora.png" alt="" class="icon-info">
                            <h5>Horario</h5>
                            <div v-html="curso.horario"></div>
                            <img src="@/assets/img/logos_cursos/metodologia.png" alt="" class="icon-info mt-3">
                            <h5>METODOLOGÍA</h5>
                            <div v-html="curso.metodologia"></div>
    
    
    
                        </div>
                        <div class="col-md-6 flex-column text-center ">
                            <img src="@/assets/img/logos_cursos/proximas_ediciones.png" alt="" class="icon-info">
                            <h5>Próximas Ediciones</h5>
                            <div v-html="curso.proximas_ediciones"></div>
                        </div>
    
                    </div>
    
                </div>
                <div class="col-md-4">
                    <h4 class="title-studio-item">INVERSIÓN</h4>
                    <div v-html="curso.inversion"></div>
                    <h4 class="title-studio-item">FORMA DE PAGO</h4>
                    <div v-html="curso.forma_pago"></div>
                    <h4 class="title-studio-item">INSCRIPCIÓN</h4>
                    <div v-html="curso.incripcion"></div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-12 pb-5">
    
                    <h4 class="title-studio-item title-studio-item-marron">CONTENIDOS</h4>
    
                    <div v-html="curso.contenidos" class="mt-4">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 ">
                    <h4 class="title-studio-item-marron">DOCENTES</h4>
                    <div v-html="curso.docentes" class="mt-4">
                    </div>
                </div>
                <div class="col-md-12 pb-5">
                    <hr>
                        <div v-on:click="shareOverrideOGMeta(ruta,curso.titulo,curso.contenido_facebook,portada)" class="facebook-share facebook-color pr-3">
                        <i class="fab fa-facebook"></i> Facebook
                        </div>
                </div>
            </div>
        </div>
    
    </div>
</template>

<script>
export default {
    data() {
        return {
            curso: {},
            portada: '',
            ruta:''
        }
    },
    methods: {
        loadSeccion() {
            this.$http.get(`https://espais.com.py/admin/api/1.1/tables/cursos/rows/${this.$route.params.id}`)
                .then(function(data) {
                    this.ruta = `https://espais.com.py/#/curso/curso/${this.$route.params.id}`
                    this.portada = "https://espais.com.py" + data.body.data.imagen_fondo.data.url
                    this.curso = data.body.data;
                })
        },
        shareOverrideOGMeta(overrideLink, overrideTitle, overrideDescription, overrideImage) {
            console.log("entra al menos");
            FB.ui({
                    method: 'share_open_graph',
                    action_type: 'og.likes',
                    action_properties: JSON.stringify({
                        object: {
                            'og:url': overrideLink,
                            'og:title': overrideTitle,
                            'og:description': overrideDescription,
                            'og:image': overrideImage
                        }
                    })
                },
                function(response) {
                    console.log(response);
                    // Action after response
                });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.loadSeccion();

        })
    },
    created() {
        window.fbAsyncInit = function() {
            FB.init({
                appId: '2158408504417471',
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v2.10'
            });
            FB.AppEvents.logPageView();
        };

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    },
}
</script>



// WEBPACK FOOTER //
// src/components/cursos/Curso.vue